export default __webpack_public_path__ + "static/media/Snd_1_Starts.dcd683d1.mp3";